import React from 'react'
import Layout from '../layout/layout'
// import Getappliedjobs from './components/jobpages/getappliedjobs';
// import Getappliedjobs   
import Getappliedjobs from '../jobpages/getappliedjobs';
// D:\mywebdevelopment\Job_portal\client\login\src\components\jobpages\getappliedjobs.js
// import Getappliedjobs
function Dashboard() {
  return (
    <Layout>
      {/* <h1> hi hello welcome to the dashboard page</h1> */}
      <Getappliedjobs/>
      
    </Layout>
  )
}

export default Dashboard
